module.exports = __webpack_public_path__ + "static/images/components/Back/images/back.719dda72.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/back.png
// module id = 2491
// module chunks = 11